import Descriptions from 'antd/es/descriptions';
import Card from 'antd/es/card';
import { Button, Col, Row } from 'antd';
import { useUnit } from 'effector-react';
import style from './ProfileRestyle.module.css';
import ServicesTree from './ProfileRestyleComponents/ServicesTree.jsx';
import CompetitiveLevel from './ProfileRestyleComponents/CompetitiveLevel.jsx';
import profile_analytics from '../../assets/profile_analytics.png';
import profile_calendar from '../../assets/profile_calendar.png';
import profile_polls from '../../assets/profile_polls.png';
import {
  $userInfo,
  changeProfileActiveTabEv,
  changeServiceActiveTabEv,
} from '../../models/authModel/index.js';

function ProfileRestyle() {
  const userInfo = useUnit($userInfo);
  const changeProfileActiveTab = useUnit(changeProfileActiveTabEv);
  const changeServiceActiveTab = useUnit(changeServiceActiveTabEv);

  const onSubscribeClick = () => {
    changeProfileActiveTab('npp-services');
    changeServiceActiveTab('premium-support');
  };

  const desc_data = [
    {
      label: 'БИН',
      span: 1,
      children: '20100000000',
    },
    {
      label: 'Юридический адрес',
      span: 1,
      children: 'г. Астана, пр. Кабанбай батыра 19',
    },
    {
      label: 'Дата регистрации',
      span: 1,
      children: '10.10.2000',
    },
    {
      label: 'Тел',
      span: 1,
      children: '+77010010001',
    },
    {
      label: 'Первый руководитель',
      span: 1,
      children: 'Омаров Бекзат Тахирович',
    },
    {
      label: 'E-mail',
      span: 1,
      children: 'info@polyservices.kz',
    },
    {
      label: 'Вид деятельности',
      span: 1,
      children: 'Производство минеральной и неметаллической продукции',
    },
    {
      label: 'Категория субъекта',
      span: 1,
      children: 'Средний бизнес',
    },
    {
      label: 'Количество работников',
      span: 1,
      children: '235',
    },
    {
      label: 'Статус плательщика ОЧВ',
      span: 1,
      children: userInfo?.mmf_payed ? 'Оплатил' : 'Не оплатил',
    },
    {
      label: 'Статус подписки',
      span: 1,
      children: (
        <div>
          Не активна <Button onClick={onSubscribeClick}>Подписаться</Button>
        </div>
      ), // FIXME Add ternary operator Активна/Не активна
    },
    {
      label: 'Доля внутристрановой ценности (ДВЦ)',
      span: 1,
      children: '2 категория (70 баллов)',
    },
  ];

  return (
    <div style={{ marginBottom: 20 }}>
      <div className={style.profile_title}>ТОО «Polytech Services»</div>
      <div className={style.profile_top}>
        <Descriptions
          items={desc_data}
          column={2}
          className={style.profile_desc}
        />
        <div className={style.profile_buttons}>
          <Card
            className={style.profile_button_card}
            size="small"
            bodyStyle={{ height: '100%' }}
          >
            <div className={style.profile_button_card_wrapper}>
              <div>Отраслевая аналитика</div>
              <img
                src={profile_analytics}
                className={style.profile_button_card_img}
              />
            </div>
          </Card>
          <Card
            className={style.profile_button_card}
            size="small"
            bodyStyle={{ height: '100%' }}
          >
            <div className={style.profile_button_card_wrapper}>
              <div>Пройти опрос</div>
              <img
                src={profile_calendar}
                className={style.profile_button_card_img}
              />
            </div>
          </Card>
          <Card
            className={style.profile_button_card}
            size="small"
            bodyStyle={{ height: '100%' }}
          >
            <div className={style.profile_button_card_wrapper}>
              <div>Календарь отчетов</div>
              <img
                src={profile_polls}
                className={style.profile_button_card_img}
              />
            </div>
          </Card>
        </div>
      </div>
      <Row gutter={[10, 10]}>
        <Col span={6}>
          <ServicesTree />
        </Col>
        <Col span={18}>
          <CompetitiveLevel />
        </Col>
      </Row>
    </div>
  );
}

export default ProfileRestyle;
